const ChangeDate = (dateString) => {
    const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
    const date = new Date(timestamp);
    const formattedDate = date.toISOString().replace('T', '-').split('.')[0].replace(/-/g, '.');

    return formattedDate;
}

export default ChangeDate;